"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _infoIcon = _interopRequireDefault(require("../icons/infoIcon"));

var _infoTooltipModule = _interopRequireDefault(require("./infoTooltip.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var InfoTooltip = function InfoTooltip(props) {
  var id = props.id,
      text = props.text,
      variant = props.variant,
      style = props.style,
      icon = props.icon,
      _props$tooltipTestId = props.tooltipTestId,
      tooltipTestId = _props$tooltipTestId === void 0 ? 'tooltipTestID' : _props$tooltipTestId;

  var ENUM_ICONS_STATES = function ENUM_ICONS_STATES(id, style, icon) {
    return {
      info: _react.default.createElement(_infoIcon.default, {
        id: "".concat(id, "_icon")
      }),
      alert: _react.default.createElement("div", {
        style: style ? style : null,
        className: (0, _classnames.default)(_infoTooltipModule.default["custom-tooltip"])
      }, "\u26A0"),
      error: _react.default.createElement("div", {
        style: style ? style : null,
        className: (0, _classnames.default)(_infoTooltipModule.default["custom-tooltip"])
      }, "\u2612"),
      custom: _react.default.createElement("div", {
        style: style ? style : null,
        className: (0, _classnames.default)(_infoTooltipModule.default["custom-tooltip"])
      }, icon && icon['type'] ? icon['type'] : icon)
    };
  };

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var onMouseEnter = function onMouseEnter() {
    return setIsHovered(true);
  };

  var onMouseLeave = function onMouseLeave() {
    return setIsHovered(false);
  };

  return _react.default.createElement("div", {
    id: id ? "".concat(id, "_wrapper") : null,
    className: (0, _classnames.default)(_infoTooltipModule.default["hidden-xs"], _infoTooltipModule.default["col-sm-1"], _infoTooltipModule.default["col-central-text"]),
    "data-toggle": "tooltip",
    title: "",
    "data-placement": "top",
    "data-testid": tooltipTestId
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_icon_wrapper") : null,
    style: {
      display: "inline-block"
    },
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, !variant ? _react.default.createElement("div", null, ENUM_ICONS_STATES(id, style, icon)["info"]) : _react.default.createElement("div", null, ENUM_ICONS_STATES(id, style, icon)[variant])), isHovered && _react.default.createElement("div", {
    id: id ? "".concat(id, "_text") : null,
    className: (0, _classnames.default)(_infoTooltipModule.default["tooltip"], _infoTooltipModule.default["fade"], _infoTooltipModule.default["top"], _infoTooltipModule.default["in"]),
    role: "tooltip"
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_arrow") : null,
    className: _infoTooltipModule.default["tooltip-arrow"]
  }), _react.default.createElement("div", {
    id: id ? "".concat(id, "_text_inner") : null,
    className: _infoTooltipModule.default["tooltip-inner"]
  }, text)));
};

InfoTooltip.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** String text of the tooltip */
  text: _propTypes.default.string.isRequired,

  /** Type of  tooltip */
  variant: _propTypes.default.string,

  /** Additional style to tooltip */
  style: _propTypes.default.object,

  /** Custom label to tooltip */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /**Test ID for Tooltip*/
  tooltipTestId: _propTypes.default.string
};
var _default = InfoTooltip;
exports.default = _default;